$(document).ready(function () {
    $(".navigation").setup_navigation();
});

$.fn.setup_navigation = function (settings) {
    settings = $.extend(
        {
            menuHoverClass: "navigation__list--show-menu"
        },
        settings
    );

    const nav = $(this);
    const isMobile = window.matchMedia("(hover: none), (pointer: coarse)").matches;

    if (isMobile) {
        return;
    }
    const supportsHover = window.matchMedia("(hover: hover)").matches;
    const isTouch = window.matchMedia("(pointer: coarse)").matches;
    const parentLinkSelector = ".navigation__item--has-dropdown > .navigation__link";

    function getSubmenu($link) {
        return $link.closest("li").children("ul").first();
    }

    function getTrigger($submenu) {
        return $submenu.closest("li").children(".navigation__link").first();
    }

    function setMenuState($submenu, isOpen) {
        const $trigger = getTrigger($submenu);

        if (isOpen) {
            $submenu
                .attr("aria-hidden", "false")
                .removeAttr("inert")
                .addClass(settings.menuHoverClass)
                .find("a")
                .attr("tabIndex", 0);

            if ($trigger.length) {
                $trigger.attr("aria-expanded", "true");
            }
        } else {
            $submenu
                .attr("aria-hidden", "true")
                .attr("inert", "")
                .removeClass(settings.menuHoverClass)
                .find("a")
                .attr("tabIndex", -1);

            if ($trigger.length) {
                $trigger.attr("aria-expanded", "false");
            }
        }
    }

    function closeMenuTree($submenu) {
        if (!$submenu.length) {
            return;
        }

        $submenu.find("ul." + settings.menuHoverClass).each(function () {
            closeMenuTree($(this));
        });

        const $active = $(document.activeElement);

        if ($active.length && $submenu.has($active).length) {
            const $trigger = getTrigger($submenu);

            if ($trigger.length) {
                $trigger[0].focus();
            } else {
                $active.blur();
            }
        }

        setTimeout(function () {
            setMenuState($submenu, false);
        }, 0);
    }
    function closeSiblingMenus($link) {
        const $li = $link.closest("li");

        $li
            .siblings()
            .children("ul." + settings.menuHoverClass)
            .each(function () {
                closeMenuTree($(this));
            });
    }
    function openMenu($link) {
        const $submenu = getSubmenu($link);

        if (!$submenu.length) {
            return;
        }

        closeSiblingMenus($link);
        setMenuState($submenu, true);
    }

    function closeAllMenus() {
        nav.find("li > ul." + settings.menuHoverClass).each(function () {
            closeMenuTree($(this));
        });
    }

    nav.find("li > ul").each(function () {
        const $submenu = $(this);
        const $trigger = getTrigger($submenu);

        setMenuState($submenu, false);

        if ($trigger.length) {
            $trigger.parent("li").attr("aria-haspopup", "true");
            $trigger.attr("aria-expanded", "false");
        }
    });

    if (isTouch) {

        nav.on("click", parentLinkSelector, function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const $link = $(this);
            const $submenu = getSubmenu($link);
            const isOpen = $submenu.hasClass(settings.menuHoverClass);

            if (isOpen) {
                closeMenuTree($submenu);
            } else {
                openMenu($link);
            }

            return false;
        });
    } else {

        nav.on("click", parentLinkSelector, function (e) {
            const $link = $(this);
            const $submenu = getSubmenu($link);
            const isOpen = $submenu.hasClass(settings.menuHoverClass);

            if (!isOpen) {
                e.preventDefault();
                e.stopImmediatePropagation();
                openMenu($link);
            }
        });
    }

    if (supportsHover && !isTouch) {

        let openTimer;
        let closeTimer;

        nav.on("mouseenter", parentLinkSelector, function () {

            const $link = $(this);

            clearTimeout(closeTimer);
            clearTimeout(openTimer);

            openTimer = setTimeout(function () {
                openMenu($link);
            }, 250);

        });

        nav.on("mouseleave", function () {

            clearTimeout(openTimer);
            clearTimeout(closeTimer);

            closeTimer = setTimeout(function () {
                closeAllMenus();
            }, 300);

        });
    }

    $(document).on("keyup", function (e) {
        if (e.key === "Escape") {
            closeAllMenus();
        }
    });

    $(document).on("click", function () {
        closeAllMenus();
    });

    nav.on("click", function (e) {
        e.stopPropagation();
    });

    if (!isTouch) {
        nav.on("focusout", function () {
            setTimeout(function () {
                if (!nav[0].contains(document.activeElement)) {
                    closeAllMenus();
                }
            }, 0);
        });
    }
};
